<h1 mat-dialog-title>{{ "Move_to_Folder.Move_to_Folder" | translate }}</h1>
<div mat-dialog-content>
  <br />
  <button mat-button mat-raised-button cdkFocusInitial color="primary" (click)="create()" style="float: right">
    {{ "Move_to_Folder.Create_Folder" | translate }}
  </button>
  <mat-form-field style="width: 300px">
    <input matInput type="text" placeholder="{{ 'Move_to_Folder.Filter' | translate }}" (keyup)="updateFilter($event.target.value)" />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>
  <ngx-datatable #table class="material striped" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50"
    [rowHeight]="50" [limit]="5" [rows]="filteredList">
    <ngx-datatable-column [flexGrow]="0.5" [width]="20">
      <ng-template let-value="value" let-row="row" let-rowIndex="rowIndex" name="Select" prop="Select"
        ngx-datatable-cell-template>
        <mat-radio-button (click)="getData(row, rowIndex)"> </mat-radio-button>
      </ng-template>
    </ngx-datatable-column>
    <!-- Application Select Column -->
    <ngx-datatable-column [flexGrow]="1.5" name="Name" prop="folderName" *ngIf="!isEditable[rowIndex]" [width]="50">
      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
        <p *ngIf="!isEditable[rowIndex]">{{ row.folderName }}</p>
        <span *ngIf="isEditable[rowIndex]">
          <mat-form-field>
            <input matInput value="folderDesc" [(ngModel)]="row.folderName" [disabled]="!isEditable[rowIndex]" />
          </mat-form-field>
        </span>
      </ng-template>
    </ngx-datatable-column>
    <!-- Event Column -->
    <ngx-datatable-column [flexGrow]="1.5" name="Description" prop="folderDesc" [width]="70">
      <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value" let-row="row">
        <p *ngIf="!isEditable[rowIndex]">{{ row.folderDesc }}</p>
        <span *ngIf="isEditable[rowIndex]">
          <mat-form-field>
            <input matInput value="folderDesc" [(ngModel)]="row.folderDesc" [disabled]="!isEditable[rowIndex]" />
          </mat-form-field>
        </span>
      </ng-template>
    </ngx-datatable-column>

    <!-- Column: Editing Mode-->
    <ngx-datatable-column [flexGrow]="0.5" [width]="50">
      <ng-template let-value="value" let-row="row" let-rowIndex="rowIndex" name="Action" prop="Action"
        ngx-datatable-cell-template>
        <!-- Pencil icon -->
        <div class="align-icon">
          <button mat-button title="{{ 'Move_to_Folder.Modify' | translate }}" (click)="this.isEditable[rowIndex] = !this.isEditable[rowIndex]"
            *ngIf="!this.isEditable[rowIndex]">
            <mat-icon class="white" color="primary">edit</mat-icon>
          </button>

          <!-- Save/Delete icons -->
          <button mat-button *ngIf="this.isEditable[rowIndex]" title="{{ 'Move_to_Folder.Save' | translate }}" (click)="save(row, rowIndex)">
            <mat-icon class="white" color="primary">save</mat-icon>
          </button>
          <button mat-button *ngIf="this.isEditable[rowIndex]" title="{{ 'Move_to_Folder.Cancel' | translate }}" (click)="cancel(row, rowIndex)">
            <mat-icon class="white" color="primary">close</mat-icon>
          </button>
          <button mat-button title="{{ 'Move_to_Folder.Delete' | translate }}" (click)="delete(row, rowIndex)">
            <mat-icon class="white" color="primary">delete</mat-icon>
          </button>
        </div>
      </ng-template>
    </ngx-datatable-column>
  </ngx-datatable>
</div>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>{{ "Move_to_Folder.Cancel" | translate }}</button>

  <button mat-button mat-raised-button cdkFocusInitial color="primary" (click)="move()">
    {{ "Move_to_Folder.Move" | translate }}
  </button>
</mat-dialog-actions>